const action = {
    general: 'Se produjo un error al ejecutar la acción. Inténtalo más tarde.',
    sign_in_identifier_changed: 'La acción no puede cambiar el identificador de inicio de sesión usado en esta verificación.',
};
export default Object.freeze(action);
